<template>
  <Teleport to="body">
    <transition name="fade">
      <div v-if="isOpen" class="modal-overlay" v-bind="$attrs" @click="handleBackdropClick">
        <div class="modal-content" :class="{ 'interdisciplinary-mock-modal': isInterdisciplinaryMock }">
        <div class="modal-header">
          <div class="modal-intro">
            <span class="material-symbols-outlined">info</span>
            <div class="modal-headline">
              <h1>{{ module?.name }}</h1>
            </div>
          </div>
          <div class="modal-controls" >
            <span v-if="!search"
              class="material-symbols-outlined arrow"
              @click="goToPrevModule"
              title="Previous module"
              >chevron_left</span>
            <span class="material-symbols-outlined" @click="$emit('close')">close</span>
            <span v-if="!search"
              class="material-symbols-outlined arrow"
              @click="goToNextModule"
              title="Next module"
              >chevron_right</span>
          </div>
        </div>
        <div class="modal-body">
          <div class="modal-column">
            <!-- Modal Content -->
            
            <div class="modal-section" >
                <!--
                <div class="badges" v-if="mock || required">
                  
                  <span class="mock-module-badge" v-if="mock">

                    <strong>
                      This module is a placeholder module!
                    </strong>
                    
                  </span>
                  <span class="required-module-badge" v-if="required">

                    <strong>
                      This module is a Compulsory module!
                    </strong>
                    
                  </span>
                  
                  <span class="assigned-semester-badge" v-if="!search&&!mock">
                    Assigned in:
                    <strong>
                      {{  'Semester ' + assignedSemester || '-' }}
                    </strong>
                  </span>
                  <span class="assigned-semester-badge" v-if="search">
                    <strong>
                      This module is not selected yet.
                    </strong>
                  </span>
                  <span v-if="module?.frequency&&!mock" class="frequency-badge" >{{ frequencyString }}</span>
                  
                </div>
                -->
                
                <!-- Basic Information Section -->
                <h3>Basic Information</h3>
                <div class="info-list">
                  <div v-if="module?.id && !mock && !module.suppressId" class="info-item">
                    <span class="info-label">ID:</span>
                    <span class="info-value">{{ module.id }}</span>
                  </div>
                  <div v-if="module?.ects " class="info-item">
                    <span class="info-label">ECTS:</span>
                    <span class="info-value">{{ module.ects }}</span>
                  </div>
                  <div v-if="module?.name_de && module.name_de !== module.name && !mock " class="info-item">
                    <span class="info-label">German Name:</span>
                    <span class="info-value">{{ module.name_de }}</span>
                  </div>
                  <div v-if="module?.name_en && module.name_en !== module.name && !mock" class="info-item">
                    <span class="info-label">English Name:</span>
                    <span class="info-value">{{ module.name_en }}</span>
                  </div>
                  <div v-if="module?.languages && !mock" class="info-item">
                    <span v-if="languageString.length >=3" class="info-label">Languages:</span>
                    <span v-if="languageString.length <3" class="info-label">Language:</span>
                    <span class="info-value">{{ languageString }}</span>
                  </div>
                  <div v-if="module?.department_ma !== undefined && !mock" class="info-item">
                    <span class="info-label">Department MA:</span>
                    <span class="info-value">{{ module.department_ma ? 'Yes' : 'No' }}</span>
                  </div>
                  <!-----
                  <div v-if="isUnavailable" class="info-item">
                    <span class="info-label" style="color: #d9534f;">Availability:</span>
                    <span class="info-value" style="color: #d9534f; font-weight: 500;">{{ unavailableReasonText }}</span>
                  </div>
                  <div v-if="module?.submodule !== undefined && module?.submodule!==false" class="info-item">
                    <span class="info-label">Submodule:</span>
                    <span class="info-value">{{ module.submodule ? 'Yes' : 'No' }}</span>
                  </div>
                  -->
                  <div v-if="module?.reference_semester" class="info-item">
                    <span class="info-label">Reference Semester:</span>
                    <span class="info-value">{{ module.reference_semester }}</span>
                  </div>
                  <!---
                  <div v-if="module?.exam !== undefined && module?.exam!==true" class="info-item">
                    <span class="info-label">Exam:</span>
                    <span class="info-value">{{ module.exam ? 'Yes' : 'No exams' }}</span>
                  </div>
                  -->
                  <div v-if="!mock" class="info-item">
                    <span class="info-label">Occurence:</span>
                    <span class="info-value">{{ frequencyString }}</span>
                  </div>
                  <div class="info-item" v-if="!search&&!mock">
                    <span class="info-label">Assigned to:</span>
                    <span class="info-value" :class="{'pinned-module-info': pinned}">{{  semesterDescription}}</span>
                  </div>
                  <div v-if="required" class="info-item">
                    <span class="info-label">Compulsory:</span>
                    <span class="info-value">This module is compulsory in your study program.</span>
                  </div>
                  <div class="info-item" v-if="mock">
                    <span class="info-label">Placeholder module:</span>
                    <span class="info-value" v-if="isInterdisciplinaryMock">This module is a placeholder for your interdisciplinary module. Please specify it using the dropdown below.</span>
                    <span class="info-value" v-else>This module serves as a placeholder. The offered modules of this type for this semester are not (yet) known to us.</span>
                  </div>
                </div>
              </div>
              <!-- Schedule Section -->
              <div v-if="showSchedule" class="modal-section">
                <h3>Schedule</h3>
                <div class="sessions-container">
                  <div v-for="(session, index) in module.sessions" :key="index" class="session-item">
                    <div class="session-header">
                      <span class="session-day">{{ formatDay(session.day) }}</span>
                      <span class="session-time" v-if="session.startTime && session.endTime">
                        <span class="material-symbols-outlined">schedule</span>
                        {{ formatTime(session.startTime) }} - {{ formatTime(session.endTime) }}
                      </span>
                    </div>
                    <div class="session-location-container">
                      <div v-if="session.location && session.location.location" class="location-row">
                        <span class="material-symbols-outlined location-icon">map</span>
                        <span class="session-location-text">{{ session.location.location }}</span>
                      </div>
                      <div v-if="session.location && session.location.locationName" class="location-row">
                        <span class="material-symbols-outlined location-icon">location_on</span>
                        <a
                            :href="`https://nav.tum.de/room/${session.location.detailedLocation}`"
                            target="_blank"
                            class="session-location-link"
                        >
                          {{ session.location.locationName }}
                        </a>
                      </div>
                    </div>
                  </div>  
                </div>
              </div>
              
              <!-- Prerequisites -->
              <div v-if="module?.prerequisites?.length" class="modal-section">
                <h3>Prerequisites</h3>
                <ul class="module-list">
                  <li v-for="(prereq, index) in module.prerequisites" :key="index">
                    <template v-if="getModuleName(prereq)">
                      <span class="module-list-title">{{ getModuleName(prereq) }}</span> ({{ prereq }})
                    </template>
                    <template v-else>
                      <span class="module-list-title">{{ prereq }}</span>
                    </template>
                  </li>
                </ul>
              </div>

              <!-- Dependencies -->
              <div v-if="module?.dependencies?.length" class="modal-section">
                <h3>Dependencies</h3>
                <ul class="module-list">
                  <li v-for="(dependency, index) in module.dependencies" :key="index">
                    <template v-if="getModuleName(dependency)">
                      <span class="module-list-title">{{ getModuleName(dependency) }}</span> ({{ dependency }})
                    </template>
                    <template v-else>
                      <span class="module-list-title">{{ dependency }}</span>
                    </template>
                  </li>
                </ul>
              </div>

              <!-- Exclusions -->
              <div v-if="module?.excludes?.length" class="modal-section">
                <h3>Cannot be taken with</h3>
                <ul class="module-list">
                  <li v-for="(excluded, index) in module.excludes" :key="index">
                    <template v-if="getModuleName(excluded)">
                      <span class="module-list-title">{{ getModuleName(excluded) }}</span> ({{ excluded }})
                    </template>
                    <template v-else>
                      <span class="module-list-title">{{ excluded }}</span>
                    </template>
                  </li>
                </ul>
              </div>

          </div>
          <!-- Scrollable Info Box -->
          <div class="modal-section" v-if="!mock && (module?.descriptionContents?.en?.trim() || module?.descriptionContents?.de?.trim())">
            <h3>Course Content</h3>
            <div class="scrollbox">
              <div>{{module?.descriptionContents?.en?.trim() || module?.descriptionContents?.de?.trim()}}</div>
            </div>
          </div>
            <div class="modal-section" v-if="!mock && (module?.descriptionOutcomes?.en?.trim() || module?.descriptionOutcomes?.de?.trim())">
              <h3>Course Outcomes</h3>
              <div class="scrollbox">
                <div>{{module?.descriptionOutcomes?.en?.trim() || module?.descriptionOutcomes?.de?.trim()}}</div>
              </div>
            </div>

            <!-- Specify Interdisciplinary Module Section using standard ModuleSearchDropdown -->
            <div class="modal-section specify-section" v-if="isInterdisciplinaryMock">
              <h3>Specify Module</h3>
              <div class="specify-entry">
                <ModuleSearchDropdown 
                  ref="specifyDropdownRef"
                  :groupedModules="alternativeInterdisciplinaryGroups"
                  :selectableModules="selectableAlternativeModules"
                  :hasStructureGroups="true"
                  :moduleInput="specifySearchQuery"
                  placeholder="Search interdisciplinary module..."
                  :currentSemester="assignedSemester || currentSemester"
                  :isInfoModalOpen="false"
                  :canExitModal="true"
                  @update:moduleInput="specifySearchQuery = $event"
                  @select-module="(event, mod) => selectAlternativeModule(mod)"
                  @info-click="mod => selectModuleForInfo(mod)"
                />
              </div>
            </div>
        </div>

        <div class="modal-footer">
          <!--
            <button v-if="!search && !pinned && !required && assignedSemester !== 0" @click="addToDesired()" class="modal-action-btn desired" title="Add to Desired Modules">
              <span class="material-symbols-outlined">favorite</span>
              <span class="btn-text">Add to Desired Modules</span>
            </button>
            -->
            <button v-if="!search && !required && assignedSemester !== 0" @click="addToUndesired()" class="modal-action-btn undesired" title="Add to Undesired Modules">
              <span class="material-symbols-outlined">cancel</span>
              <span class="btn-text">Remove</span>
            </button>
            <div v-if="!search && !pinned && assignedSemester !== 0" style="position: relative; display: inline-block;">
              <button
                @click="showSemesterSelect = !showSemesterSelect"
                class="modal-action-btn pin"
                title="Pin Module"
                type="button"
              >
                <span class="material-symbols-outlined">push_pin</span>
                <span class="btn-text">Pin</span>
              </button>
              <div
                v-if="showSemesterSelect"
                class="semester-select-dropdown"
                @click.stop
              >
                <div class="dropdown-title">Move and Pin Module to</div>
                <button
                  v-for="sem in semesters"
                  :key="sem"
                  class="dropdown-semester-btn"
                  @click="pinToSemester(sem)"
                >
                  {{ formatSemesterName(sem) }}
                </button>
              </div>
            </div>
            <button v-if="!search && pinned && assignedSemester !== 0" @click="unpin()" class="modal-action-btn unpin" title="Unpin Module">
              <span class="material-symbols-outlined">keep_off</span>
              <span class="btn-text">Unpin</span>
            </button>
            <button v-if="true" @click="$emit('close')" class="modal-action-btn select" title="Close">
              <span class="material-symbols-outlined">close</span>
              <span class="btn-text">Close</span>
            </button>
            <button
              v-if="search && !baseModuleModal"
              @click="selectModule()"
              class="modal-action-btn select"
              :disabled="isUnavailable"
              :title="isUnavailable ? unavailableReasonText : 'Select Module'"
            >
              <span class="material-symbols-outlined">{{ isUnavailable ? 'block' : 'check' }}</span>
              <span class="btn-text">Select</span>
            </button>
          </div>
        </div>
    </div>
  </transition>
  </Teleport>
</template>

<script>
import { mapState } from 'vuex';
import { getExplanatoryUnavailableReason, getAbsoluteSemester } from '@/utils';
import ModuleSearchDropdown from '@/components/modals/ModuleSearchDropdown.vue';

export default {
  name: "ModuleInfoModal",
  inheritAttrs: false,
  components: {
    ModuleSearchDropdown
  },
  props: {
    isOpen: Boolean,
    module: Object,
    pinableSems: {
      type: Array,
      default: () => []
    },
    assignedSemester: {
      type: Number,
      default: null
    },
    search:{
      type:Boolean,
      default:false
    },
    semesterDescription: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    pinned : {
      type: Boolean,
      default:false
    },
    inUpcomingSem: {
      type: Boolean,
      default:false
    },
    baseModuleModal: {
      type: Boolean,
      default:false
    },
    currentSemester: {
      type: Number,
      default: null
    },
    unavailableModules: {
      type: Array,
      default: () => []
    },
    unavailableReason: {
      type: String,
      default: "inactive"
    },
    openSpecifyDropdown: {
      type: Boolean,
      default: false
    },
    modalName: {
      type: String,
      default: ''
    },
    isPassed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'change-module','add-desired', 'add-undesired', 'add-desired-in-sem','select-module','unpin', 'specify-module'],
  computed: {
    ...mapState(["program", "config", "preferences", "offeredSemesters", "currentModal"]),
    isUnavailable() {
      return !!(this.module && (this.unavailableModules.includes(this.module.id) || this.module.isUnavailable));
    },
    unavailableReasonText() {
      if (!this.isUnavailable) return "";
      const reasonObj = getExplanatoryUnavailableReason(
        this.module,
        this.unavailableReason,
        this.currentSemester,
        this.preferences?.startSemester
      );
      return reasonObj.full;
    },
    mock(){
      return this.module?.mock || this.module?.mock2 || false;
    },
    isInterdisciplinary() {
      if (!this.module || !this.module.id || !this.program || !Array.isArray(this.program.blocks)) return false;
      return this.getInterdisciplinaryModuleIds().has(this.module.id);
    },
    isInterdisciplinaryMock() {
      return this.mock && this.isInterdisciplinary;
    },
    selectableAlternativeModules() {
      if (!this.program || !Array.isArray(this.program.modules) || !this.isInterdisciplinaryMock) {
        return [];
      }
      const interdModuleIds = this.getInterdisciplinaryModuleIds();
      let mods = this.program.modules.filter(m => 
        m && m.id && interdModuleIds.has(m.id) && !m.mock && !m.mock2 && this.isModuleOfferedInTargetSemester(m)
      );

      const query = (this.specifySearchQuery || '').trim().toLowerCase();
      if (query) {
        mods = mods.filter(m => {
          const name = (m.name || m.name_en || m.name_de || '').toLowerCase();
          const number = (m.number || '').toString().toLowerCase();
          const id = (m.id || '').toLowerCase();
          return name.includes(query) || number.includes(query) || id.includes(query);
        });
      }
      return mods;
    },
    alternativeInterdisciplinaryGroups() {
      if (!this.program || !Array.isArray(this.program.blocks) || !Array.isArray(this.program.modules) || !this.isInterdisciplinaryMock) {
        return [];
      }

      const matchingModuleIds = new Set(this.selectableAlternativeModules.map(m => m.id));
      const interdBlockIds = this.getInterdisciplinaryBlockIds();
      const assignedModuleIds = new Set();

      const getModuleObj = (id) => {
        if (!matchingModuleIds.has(id)) return null;
        const m = this.program.modules.find(mod => mod.id === id);
        if (!m || m.mock || m.mock2) return null;
        return m;
      };

      const buildNode = (blockId, visited = new Set()) => {
        if (visited.has(blockId)) return null;
        visited.add(blockId);

        const block = this.program.blocks.find(b => b.id === blockId);
        if (!block || block.id.toLowerCase().includes('mock')) return null;

        const modules = [];
        if (Array.isArray(block.modules)) {
          block.modules.forEach(mId => {
            const modObj = getModuleObj(mId);
            if (modObj && !assignedModuleIds.has(modObj.id)) {
              assignedModuleIds.add(modObj.id);
              modules.push(modObj);
            }
          });
          modules.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }

        const subgroups = [];
        if (Array.isArray(block.blocks)) {
          block.blocks.forEach(subId => {
            const childNode = buildNode(subId, visited);
            if (childNode && (childNode.modules.length > 0 || (childNode.subgroups && childNode.subgroups.length > 0))) {
              subgroups.push(childNode);
            }
          });
        }

        if (modules.length === 0 && subgroups.length === 0) return null;

        return {
          structure: {
            id: block.id,
            name: block.name || block.id,
            isCustomName: true
          },
          modules,
          subgroups
        };
      };

      const topBlockIds = this.program.blocks
        .filter(b => {
          if (!interdBlockIds.has(b.id)) return false;
          if (b.id.toLowerCase().includes('mock')) return false;
          const isChild = this.program.blocks.some(parent =>
            interdBlockIds.has(parent.id) && Array.isArray(parent.blocks) && parent.blocks.includes(b.id)
          );
          return !isChild;
        })
        .map(b => b.id);

      const rootNodes = [];
      const visited = new Set();
      topBlockIds.forEach(tId => {
        const node = buildNode(tId, visited);
        if (node) rootNodes.push(node);
      });

      this.program.blocks.forEach(b => {
        if (interdBlockIds.has(b.id) && !b.id.toLowerCase().includes('mock') && !visited.has(b.id)) {
          const node = buildNode(b.id, visited);
          if (node) rootNodes.push(node);
        }
      });

      const finalNodes = [];
      rootNodes.forEach(node => {
        if (node.modules.length === 0 && node.subgroups && node.subgroups.length > 0) {
          finalNodes.push(...node.subgroups);
        } else {
          finalNodes.push(node);
        }
      });

      const interdModuleIds = this.getInterdisciplinaryModuleIds();
      const remainingMods = [];
      this.program.modules.forEach(m => {
        if (m && m.id && interdModuleIds.has(m.id) && !m.mock && !m.mock2 && !assignedModuleIds.has(m.id) && matchingModuleIds.has(m.id)) {
          assignedModuleIds.add(m.id);
          remainingMods.push(m);
        }
      });

      if (remainingMods.length > 0) {
        remainingMods.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        finalNodes.push({
          structure: {
            id: 'other_interdisciplinary_courses',
            name: 'Other Interdisciplinary Courses',
            isCustomName: true
          },
          modules: remainingMods,
          subgroups: []
        });
      }

      return finalNodes;
    },
    languageString() {
      if (!Array.isArray(this.module?.languages)) return '';
      return this.module.languages.join(', ');
    },
    frequencyString() {
      const occ = this.module?.occurrence;
      let baseString = 'Offered only irregularly';
      if(occ==='w') baseString = 'Offered every winter semester';
      else if(occ==='s') baseString = 'Offered every summer semester';
      else if (occ === 'w/s' || occ ==='s/w') baseString = 'Offered in every semester';

      var unofferedRaw = this.module?.unofferedSemesters || this.module?.unoffered_semesters || [];
      const unoffered = unofferedRaw.filter(sem => sem == this.config.currentSemester).map(sem => this.formatSemesterName(sem));

      if (unoffered.length > 0) {
        if (baseString === 'Offered onlyirregularly') {
          //baseString = 'Offered only irregularly (except ' + unoffered.join(', ') + ')';
        } else {
          baseString += ' (except ' + unoffered.join(', ') + ')';
        }
      }
      return baseString;
    },
    semesters() {
      if(this.pinableSems==null || this.pinableSems.length === 0) return ["Current"];
      var semesters = this.pinableSems.filter(sem => sem !== null && sem !== undefined && sem !== this.assignedSemester);
      semesters.splice(0,0,"Current");
      return semesters;
    },
    isStartSemesterUpcoming() {
      if (!this.config || !this.config.currentSemester) return null;
      let sem = this.config.currentSemester;
      let type = sem[0];
      let year = parseInt(sem.slice(1));
      let upcoming = '';
      if (type === 's') {
        upcoming = 'w' + year;
      } else {
        upcoming = 's' + (year + 1).toString().padStart(2, '0');
      }
      return this.preferences.startSemester === upcoming;
    },
    isPassedModule() {
      if (this.isPassed) return true;
      if (this.assignedSemester === 0 || this.assignedSemester === '0') return true;
      if (this.preferences?.passedModules?.includes(this.module?.id)) return true;
      if (this.modalName === 'PassedModulesModal' || this.modalName === 'SaveSemesterChangedModal') return true;
      if (this.currentModal === 'PassedModulesModal' || this.currentModal === 'SaveSemesterChangedModal') return true;
      return false;
    },
    showSchedule() {
      if (this.isUnavailable) return false;
      if (this.isPassedModule) return false;
      if (this.isStartSemesterUpcoming) return false;
      if (!Array.isArray(this.module?.sessions) || !this.module.sessions.length) return false;
      return this.inUpcomingSem || this.search;
    },
  },
  data() {
    return {
      showSemesterSelect: false,
      specifySearchQuery: ''
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        if (this.openSpecifyDropdown && this.isInterdisciplinaryMock) {
          this.$nextTick(() => {
            if (this.$refs.specifyDropdownRef?.$refs?.input) {
              this.$refs.specifyDropdownRef.$refs.input.focus();
            }
          });
        }
      } else {
        this.showSemesterSelect = false;
        this.specifySearchQuery = '';
      }
      this.updateOutsideClickListener();
    },
    openSpecifyDropdown(val) {
      if (val && this.isOpen && this.isInterdisciplinaryMock) {
        this.$nextTick(() => {
          if (this.$refs.specifyDropdownRef?.$refs?.input) {
            this.$refs.specifyDropdownRef.$refs.input.focus();
          }
        });
      }
    },
    module() {
      this.showSemesterSelect = false;
      this.specifySearchQuery = '';
    }
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  },
  methods: {
    getModuleName(moduleId) {
      if (!moduleId) return '';
      const found = this.program?.modules?.find(m => m.id === moduleId);
      return found?.name || '';
    },
    getElement(selector) {
      if (this.$el && typeof this.$el.querySelector === 'function') {
        const el = this.$el.querySelector(selector);
        if (el) return el;
      }
      return document.querySelector(selector);
    },
    getInterdisciplinaryBlockIds() {
      if (!this.program || !Array.isArray(this.program.blocks)) return new Set();
      const interdisciplinaryIds = new Set();
      this.program.blocks.forEach(block => {
        if (
          block.interdisciplinary 
        ) {
          interdisciplinaryIds.add(block.id);
        }
      });
      let addedNew = true;
      while (addedNew) {
        addedNew = false;
        this.program.blocks.forEach(block => {
          if (interdisciplinaryIds.has(block.id) && block.blocks) {
            block.blocks.forEach(subId => {
              if (!interdisciplinaryIds.has(subId)) {
                interdisciplinaryIds.add(subId);
                addedNew = true;
              }
            });
          }
        });
      }
      return interdisciplinaryIds;
    },
    collectModulesFromBlock(blockId, blocks, visited = new Set()) {
      if (visited.has(blockId)) return [];
      visited.add(blockId);
      const block = blocks.find(b => b.id === blockId);
      if (!block) return [];
      let moduleIds = block.modules ? [...block.modules] : [];
      if (block.blocks && Array.isArray(block.blocks)) {
        block.blocks.forEach(subId => {
          moduleIds = moduleIds.concat(this.collectModulesFromBlock(subId, blocks, visited));
        });
      }
      return moduleIds;
    },
    getInterdisciplinaryModuleIds() {
      if (!this.program || !Array.isArray(this.program.blocks)) return new Set();
      const blockIds = this.getInterdisciplinaryBlockIds();
      const moduleIds = new Set();
      const visited = new Set();
      blockIds.forEach(bId => {
        const mods = this.collectModulesFromBlock(bId, this.program.blocks, visited);
        mods.forEach(id => moduleIds.add(id));
      });
      return moduleIds;
    },
    isModuleOfferedInTargetSemester(module) {
      if (!module || !module.id) return false;
      
      const targetSem = (this.assignedSemester && this.assignedSemester !== 'Current' && this.assignedSemester !== 0)
        ? Number(this.assignedSemester)
        : Number(this.currentSemester);

      // Check offeredSemesters from Vuex store (calculated by backend scheduler)
      if (this.offeredSemesters && typeof this.offeredSemesters === 'object' && this.offeredSemesters[module.id]) {
        const offeredList = this.offeredSemesters[module.id];
        if (Array.isArray(offeredList)) {
          if (!isNaN(targetSem) && targetSem > 0) {
            return offeredList.includes(targetSem);
          }
          return offeredList.length > 0;
        }
      }

      // Check occurrence and season
      const occ = module.occurrence || (this.program?.moduleOccurrences ? this.program.moduleOccurrences[module.id] : null);
      const startSem = this.preferences?.startSemester;
      
      if (!isNaN(targetSem) && targetSem > 0 && startSem && typeof startSem === 'string') {
        const absSem = getAbsoluteSemester(targetSem, startSem);
        if (absSem) {
          const unofferedRaw = module.unofferedSemesters || module.unoffered_semesters || [];
          if (Array.isArray(unofferedRaw) && unofferedRaw.includes(absSem)) {
            return false;
          }
          const season = absSem[0];
          if (occ === 'w' && season === 's') return false;
          if (occ === 's' && season === 'w') return false;
        }
      }

      if (occ && !['w', 's', 'w/s', 's/w'].includes(occ.toLowerCase())) {
        return false;
      }

      return true;
    },
    selectAlternativeModule(altMod) {
      this.$emit('specify-module', {
        mockModuleId: this.module.id,
        realModuleId: altMod.id,
        semester: this.assignedSemester
      });
      this.$emit('close');
    },
    selectModuleForInfo(mod) {
      this.$emit('change-module', mod);
    },
    updateOutsideClickListener() {
      if (this.showSemesterSelect || this.showSpecifyDropdown) {
        document.addEventListener('mousedown', this.handleOutsideClick);
      } else {
        document.removeEventListener('mousedown', this.handleOutsideClick);
      }
    },
    handleBackdropClick(e) {
      if (e.target.classList.contains('modal-overlay')) {
        this.$emit('close');
      }
    },
    formatTime(timeString) {
      if (!timeString) return '';
      if (typeof timeString === 'string') {
        return timeString.includes(':') ? timeString.slice(0, 5) : timeString;
      }
      return timeString.toString();
    },
    formatDay(dayString) {
      if (typeof dayString !== 'string') return '';
      const dayMap = {
        'mon': 'Monday',
        'tue': 'Tuesday',
        'wed': 'Wednesday',
        'thu': 'Thursday',
        'fri': 'Friday',
        'sat': 'Saturday',
        'sun': 'Sunday'
      };
      return dayMap[dayString.toLowerCase()] || dayString;
    },
    goToPrevModule() {
      this.$emit('change-module', 'prev');
    },
    goToNextModule() {
      this.$emit('change-module', 'next');
    },
    pinToSemester(sem) {
      
      this.showSemesterSelect = false;
      this.$emit('add-desired-in-sem', { moduleId: this.module.id, semester : sem });
      if (sem !== 'Current') {
        this.$emit('close');
      }
    },
    unpin(){
      this.$emit('unpin', this.module.id);
      this.$emit('close');
    },
    addToDesired() {
      this.$emit('add-desired', this.module.id);
      this.$emit('close');
      
    },
    addToUndesired(moduleId) {
      this.$emit('add-undesired', moduleId);
      this.$emit('close');
    },
    selectModule() {
      this.$emit('close');
      this.$emit('select-module', this.module.id);
    },
    handleOutsideClick(e) {
      const dropdown = this.getElement('.semester-select-dropdown');
      const pinBtn = this.getElement('.modal-action-btn.pin');
      if (
        dropdown &&
        !dropdown.contains(e.target) &&
        pinBtn &&
        !pinBtn.contains(e.target)
      ) {
        this.showSemesterSelect = false;
      }

      const specifyDropdown = this.getElement('.specify-select-dropdown');
      const specifyBtn = this.getElement('.modal-action-btn.specify');
      if (
        specifyDropdown &&
        !specifyDropdown.contains(e.target) &&
        specifyBtn &&
        !specifyBtn.contains(e.target)
      ) {
        this.showSpecifyDropdown = false;
      }
    },
    formatSemesterName(e) {
      if(e==='Current') {
        return 'Current Semester';
      }
      if (typeof e === 'string' && /^[ws]\d{2}$/.test(e)) {
        const season = e.startsWith('w') ? 'winter semester' : 'summer semester';
        const year = `20${e.slice(1)}`;
        return `${season} ${year}`;
      }
      return 'Semester ' + e;
    }
  },
};
</script>

<style scoped>

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start; 
  padding-top: 15vh; 
  z-index: 10002 !important;
}

.modal-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  width: 75%;
  max-width: 960px;
  max-height: 80vh; 
  color: #333333;
}

.interdisciplinary-mock-modal {
  width: 75%;
  max-width: 960px;
  overflow: visible !important;
}

.interdisciplinary-mock-modal .modal-body {
  overflow: visible !important;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #ddd;
  flex-shrink: 0;
}

.modal-intro {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
}

.modal-intro .material-symbols-outlined {
  font-size: 28px;
  color: #9ABCE4;
}

.modal-headline {
  display: flex;
  flex-direction: column;
}

h1 {
  font-size: 18px;
  margin: 0 0 4px 0;
  font-weight: 500;
}

.modal-subtitle {
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.badges {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0px;
  flex-wrap: wrap;
}

.frequency-badge {
  /*/background-color: #e6f0fa;/*/
  outline: dashed 1px rgb(170, 181, 192);
  padding: 0px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.assigned-semester-badge {
  outline: dashed 1px rgb(170, 181, 192);
  padding: 0px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 3px;
}
.mock-module-badge {
  outline: dashed 1.5px #911212;
  background-color: rgb(255, 233, 233);
  padding: 0px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 3px;
}
.required-module-badge {
  outline: dashed 1.5px #000000;
  padding: 0px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 3px;
}

.modal-controls {
  display: flex;
  align-items: center;
}

.modal-controls .material-symbols-outlined {
  padding: 6px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.modal-controls .material-symbols-outlined:hover {
  background-color: #f5f5f5;
}

.arrow {
  cursor: pointer;
  user-select: none;
  font-size: 28px;
  margin: 0 4px;
  color: #9ABCE4;
  transition: background 0.2s, color 0.2s;
}

.modal-body {
  flex: 1;
  overflow: auto;
  padding: 20px 25px;
}

.modal-column {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.modal-section {
  margin-bottom: 0;
}

.modal-section h3 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 2px;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2px 0;
  gap: 6px;
}

.info-label {
  font-size: 13px;
  color: #2a2a2a;
  font-weight: 600;
  flex-shrink: 0;
}

.info-value {
  font-size: 13px;
  text-align: left;
  flex: 1;
}

.sessions-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 12px; 
}

.session-item {
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  background-color: #fafbfc;
  border-radius: 8px;
  border-left: 4px solid #9ABCE4;
  gap: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.session-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.08);
}

.session-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  border-bottom: 1px solid #ebf0f5;
  padding-bottom: 6px;
  margin-bottom: 2px;
}

.session-day {
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.session-time {
  font-size: 12px;
  color: #0065bd;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid #9ABCE4;
}

.session-time .material-symbols-outlined {
  font-size: 14px;
}

.module-list {
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 1.2;
}

.module-list-title {
  font-weight: 600;
  color: #333;
}

.module-list li {
  padding: 6px 0;
  font-size: 13px;
  border-bottom: 1px solid #f0f0f0;
}

.module-list li:last-child {
  border-bottom: none;
}

.structure-info p {
  margin: 0 0 10px 0;
  font-size: 13px;
  font-style: italic;
  color: #666;
}

.mock-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d95117;
  background-color: #fff8f6;
  padding: 12px;
  border-radius: 6px;
  font-size: 13px;
}

.mock-notice .material-symbols-outlined {
  font-size: 18px;
}

.empty-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #999;
  text-align: center;
}

.empty-column .material-symbols-outlined {
  font-size: 48px;
  margin-bottom: 10px;
  opacity: 0.5;
}

.empty-column p {
  margin: 0;
  font-size: 14px;
  font-style: italic;
}

.modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 20px 25px;
  border-top: 1px solid #ddd;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.modal-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 5px;
  border: 1px solid #9ABCE4;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  background: white;
  color: #9ABCE4;
}

.modal-action-btn:disabled {
  background: #f5f5f5 !important;
  color: #ccc !important;
  border-color: #ddd !important;
  cursor: not-allowed !important;
}

.modal-action-btn .btn-text {
  opacity: 1;
  white-space: nowrap;
}

.modal-action-btn .material-symbols-outlined {
  font-size: 16px;
  vertical-align: middle;
}

.modal-action-btn.desired,
.modal-action-btn.undesired,
.modal-action-btn.select,
.modal-action-btn.unpin,
.modal-action-btn.specify,
.modal-action-btn.pin {
  background: white;
  color: #9ABCE4;
  border: 1px solid #9ABCE4;
}
.modal-action-btn.desired:hover,
.modal-action-btn.undesired:hover,
.modal-action-btn.unpin:hover,
.modal-action-btn.specify:hover,
.modal-action-btn.select:hover,
.modal-action-btn.pin:hover {
  background: #f4f8fc;
  color: #5E94D4;
  border-color: #5E94D4;
}



.pinned-module-info{
  color: #007220;
}

/* Responsive design */
@media (max-width: 600px) {
  .modal-content {
    width: 95%;
    max-height: 90vh;
  }
  
  .empty-column {
    display: none;
  }
}

/* Transition effects */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active .modal-content,
.fade-leave-active .modal-content {
  transition: transform 0.3s ease;
}

.fade-enter-from .modal-content,
.fade-leave-to .modal-content {
  transform: translateY(-20px);
}

.semester-select-dropdown {
  position: absolute;
  bottom: 110%;
  left: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  padding: 8px 12px;
  min-width: 140px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: #ffffff;
  border-left: 3px solid #9ABCE4;
}

.specify-section {
  margin-top: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 14px 16px 14px;
  position: relative;
  z-index: 20;
}

.specify-section h3 {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1e3a8a;
}

.specify-entry {
  position: relative;
  width: 100%;
}

.dropdown-title {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
  color: #333;
}

.dropdown-semester-btn {
  display: block;
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  padding: 4px 0;
  font-size: 13px;
  color: #1976d2;
  cursor: pointer;
  border-radius: 3px;
  transition: background 0.15s;

}
.dropdown-semester-btn:hover {
  background: #e3f2fd;
}

/* Scrollable Info Box */
.scrollbox {
  max-height: 90px;          
  overflow-y: auto;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: #fafafa;
  font-size: 13px;
  line-height: 1.5;
  color: #333;
  border-left: 3px solid #9ABCE4;
  white-space: pre-line; /* Preserve line breaks */
}

/* scrollbar - webkit */
.scrollbox::-webkit-scrollbar {
  width: 8px;
}
.scrollbox::-webkit-scrollbar-track {
  background: transparent;
}
.scrollbox::-webkit-scrollbar-thumb {
  background: #c7d6e5;
  border-radius: 4px;
}
.scrollbox::-webkit-scrollbar-thumb:hover {
  background: #9abce4;
}

/* scrollbar - firefox */
.scrollbox {
  scrollbar-width: thin;
  scrollbar-color: #c7d6e5 transparent;
}
.session-location-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.location-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 13px;
  color: #555;
  line-height: 1.4;
}

.location-icon {
  font-size: 16px;
  color: #798c9e;
  margin-top: 1px;
}

.session-location-text {
  flex: 1;
}

.session-location-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.session-location-link:hover {
  text-decoration: underline;
  color: #1565c0;
}

</style>